import React, { useEffect } from 'react';
import useMaskyoo from '../../../../utilities/hooks/useMaskyoo';
export default function MaskyooForm(props) {

    const maskyooPhoneNumber = useMaskyoo();

    useEffect(() => {
        if (maskyooPhoneNumber) {
            props.onFinishLoading();
        }
        else {
            props.onStartLoading();
        }
    });

    return (
        <div className="dialer-form container">
            <div className="row">
                <div className="col-12">
                    <h1>{props.title}</h1>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <h2>{props.subtitle}</h2>
                </div>
            </div>
            <div className="row pt-3">
                <div className="col-12 dialer-button-wrapper">
                    <a href={`tel:${maskyooPhoneNumber}`} className="dialer-button" />
                </div>
            </div>
            <div className="row pt-2">
                <div className="col-12">לחצו לשיחה</div>
            </div>
        </div>
    )
}
